/* Example of use: /transactions => click New ledger entry => choose any type, e.g. Bank transfer */
/* At the bottom there's a file selector + selected files list */
/* Constrained view displayed on incorrect scope. Otherwise attachments-list */
var AttachmentsList = require('./attachments-list')

module.exports = AttachmentsList.extend({
    layoutName: 'components/attachments-list-constrained',

    isDisabled: function() {
        var constraints = this.container.lookup('service:constraints')
        return !constraints.hasScope('transaction_attachment')
    }.property(),

    isUploadButtonDisabled: function() {
        return this.get('isDisabled')
    }.property(),

    isFileUploadAllowed: function() {
        return !this.get('isDisabled')
    }.property()
})
